import {BaseModel} from '../_base/crud';
import {UserModel} from './user.model';
import { ConversationModel } from './conversation.model';
import { MessageModel } from './message.model';

/**
 * 担当者待ち SUUMO以外で使う
 */
export const PROJECT_STATUS_WAITING_PERSON_IN_CHARGE = 0;
/**
 * 顧客待ち SUUMO以外で使う
 */
export const PROJECT_STATUS_WAITING_CUSTOMER = 1;
/**
 * 処理中 SUUMO以外で使う
 */
export const PROJECT_STATUS_PROCESSING = 2;
/**
 * 完了 SUUMO以外で使う（使わない？）
 */
export const PROJECT_STATUS_COMPLETE = 3;
/**
 * 製作中 SUUMOでもSUUMO以外で使う
 */
export const PROJECT_STATUS_UNDER_CONSTRUCTION = 4;
/**
 * 納品 SUUMO以外で使う
 */
export const PROJECT_STATUS_DELIVERY = 5;
/**
 * 見込み SUUMO以外で使う
 */
export const PROJECT_STATUS_PROSPECT = 6;
/**
 * 制作 SUUMO以外で使う（使わない？）
 */
export const PROJECT_STATUS_CONSTRUCTION = 7;
/**
 * 画像アップロード待ち SUUMOで使う
 */
export const PROJECT_STATUS_WAITING_CUSTOMER_DOCUMENT = 8;
/**
 * アングル作成中 SUUMOで使う
 */
export const PROJECT_STATUS_WAITING_ANGLE = 9;
/**
 * アングル選択中 SUUMOで使う
 */
export const PROJECT_STATUS_WAITING_SELECT_ANGLE = 10;
/**
 * SUUMO校閲中 SUUMOで使う
 */
export const PROJECT_STATUS_SUUMO_REVIEW = 11;
/**
 * CL（クライアント）校閲中 SUUMOで使う
 */
export const PROJECT_STATUS_CLIENT_REVIEW = 12;
/**
 * 修正中 SUUMOで使う
 */
export const PROJECT_STATUS_FIX = 13;
/**
 * 納品完了 SUUMOで使う
 */
export const PROJECT_STATUS_DELIVERY_COMPLETE = 14;
/**
 * 削除済み 検索に出ない
 */
export const PROJECT_STATUS_ARCHIVED = 15;
/**
 * ロスト 検索に出る
 */
export const PROJECT_STATUS_LOST = 16;

export const PROJECT_STATUSES = [
    PROJECT_STATUS_WAITING_PERSON_IN_CHARGE,
    PROJECT_STATUS_WAITING_CUSTOMER,
    PROJECT_STATUS_PROCESSING,
    PROJECT_STATUS_COMPLETE,
    PROJECT_STATUS_UNDER_CONSTRUCTION,
    PROJECT_STATUS_DELIVERY,
    PROJECT_STATUS_PROSPECT,
    PROJECT_STATUS_CONSTRUCTION,
    PROJECT_STATUS_WAITING_CUSTOMER_DOCUMENT,
    PROJECT_STATUS_WAITING_ANGLE,
    PROJECT_STATUS_WAITING_SELECT_ANGLE,
    PROJECT_STATUS_SUUMO_REVIEW,
    PROJECT_STATUS_CLIENT_REVIEW,
    PROJECT_STATUS_FIX,
    PROJECT_STATUS_DELIVERY_COMPLETE,
    PROJECT_STATUS_ARCHIVED,
    PROJECT_STATUS_LOST,
] as const;
export type ProjectStatus = typeof PROJECT_STATUSES[number];

export const PROJECT_STATUS_NAMES = {
    [PROJECT_STATUS_WAITING_PERSON_IN_CHARGE]: '担当者待ち',
    [PROJECT_STATUS_WAITING_CUSTOMER]: '顧客待ち',
    [PROJECT_STATUS_PROCESSING]: '処理中',
    [PROJECT_STATUS_COMPLETE]: '完了',
    [PROJECT_STATUS_UNDER_CONSTRUCTION]: '製作中',
    [PROJECT_STATUS_DELIVERY]: '納品',
    [PROJECT_STATUS_PROSPECT]: '見込み',
    [PROJECT_STATUS_CONSTRUCTION]: '制作',
    [PROJECT_STATUS_WAITING_CUSTOMER_DOCUMENT]: '画像アップロード待ち',
    [PROJECT_STATUS_WAITING_ANGLE]: 'アングル作成中',
    [PROJECT_STATUS_WAITING_SELECT_ANGLE]: 'アングル選択中',
    [PROJECT_STATUS_SUUMO_REVIEW]: 'SUUMO校閲中',
    [PROJECT_STATUS_CLIENT_REVIEW]: 'CL校閲中',
    [PROJECT_STATUS_FIX]: '修正中',
    [PROJECT_STATUS_DELIVERY_COMPLETE]: '納品完了',
    [PROJECT_STATUS_ARCHIVED]: '削除済み',
    [PROJECT_STATUS_LOST]: 'ロスト',
} as const;

export class ProjectModel extends BaseModel {
    id: number;
    lastProjectEditId: number;
    createdBy: any;
    details: string;
    language: string;
    name: string;
    fromDate: string;
    toDate: string;
    dateOfDelivery: string | null;
    scheduledDateOfDelivery: string;
    timeOfDelivery: string;
    // drawingNotAvailable: number;
    // sunsetOrNightView: number;
    // highQuality: number;
    // diff: string;
    additionalUrls: string;
    price: number | null;
    angleNumber: number | null;
    draftCheckFileId: number | null;
    secondDraftCheckFileId: number | null;
    thirdDraftCheckFileId: number | null;
    /**
     * 現在レビュー中のドラフトの番号。
     * 初期値は0（まだ何もレビューしていないので）
     * 
     * 3の次は1（studio55側が3までだと言うので）
     */
    draftNumber: number;
    deliveryFileId: number | null;
    deliveryFileName: string | null;

    primaryConversationId: number | null;

    commentOnDelivery: string;
    isArchived: number;
    isDeleted: number;
    createdAt: string;
    modifiedAt: string;
    status: ProjectStatus;
    health: number;
    /**
     * SalesForceの商談のID
     */
    salesforceId?: string ;

    users: UserModel[];
    managedBy?: number;
    managerName?: string;
    // managedByUser: any;

    // 作成用の追加データ
    conversation?: ConversationModel;
    systemMessage?: MessageModel;

    clear() {
        this.id = 0;
        this.lastProjectEditId = 0;
        this.createdBy = undefined;
        this.details = '';
        this.language = '';
        this.name = '';
        this.fromDate = '';
        this.toDate = '';
        this.dateOfDelivery = null;
        this.scheduledDateOfDelivery = '';
        this.timeOfDelivery = '';
        this.isArchived = 0;
        this.isDeleted = 0;
        this.createdAt = '';
        this.modifiedAt = '';
        this.status = 0;
        this.health = 0;
        this.salesforceId = undefined;

        this.users = [];
        this.managedBy = undefined;
    }
}
